import { useDevAgentStore } from "@/stores/devAgentStore";
import { DEV_AGENT_BASE_URL, devAgentAuthHeaders } from "../devAgentService";
import { env } from "@/config/env";
import { S, clearThinking } from "./sseFeedHelpers";
import { sseState } from "./sseMutableState";

export function buildDevAgentSseRequest(params: {
  sessionUuid: string;
  lastEventId: string;
  sseTicket: string | null;
}) {
  const sessionUuid = String(params.sessionUuid ?? "").trim();
  if (!sessionUuid) {
    console.warn("[SSE] buildDevAgentSseRequest: missing or empty chat_session_uuid — refusing URL");
    return { url: "", headers: {} as Record<string, string> };
  }
  const base = env.DIRECT_SSE_URL || DEV_AGENT_BASE_URL;
  const ticketQuery = params.sseTicket ? `&ticket=${params.sseTicket}` : "";
  const url =
    `${base}/api/agui/sse?chat_session_uuid=${encodeURIComponent(sessionUuid)}` +
    `&last_event_id=${encodeURIComponent(params.lastEventId)}${ticketQuery}`;
  return {
    url,
    headers: {
      "Last-Event-ID": params.lastEventId,
      // Raw fetch bypasses the axios interceptor entirely — Authorization/
      // tenant headers have to be attached explicitly here. Auth was
      // previously carried solely by the `?ticket=` query param.
      ...devAgentAuthHeaders(),
    },
  };
}

function clearStuckTimer() {
  if (!sseState.stuckTimer) return;
  clearTimeout(sseState.stuckTimer);
  sseState.stuckTimer = null;
}

function markRunningToolsDone() {
  sseState.toolCallMap.forEach((feedId) => {
    S().updateFeedItem(feedId, { status: "done" });
  });
  sseState.toolCallMap.clear();
}

export function resetSseRuntimeForConnect(processedIds: Set<string>) {
  processedIds.clear();
  if (S().streamingContent) {
    useDevAgentStore.setState({ streamingContent: null });
  }
  sseState.finalized = false;
  sseState.saveResultSeen = false;
}

export function resetSseRuntimeForSession(processedIds: Set<string>) {
  sseState.toolCallMap.clear();
  sseState.activeThinkingId = null;
  sseState.finalized = false;
  sseState.saveResultSeen = false;
  sseState.openedFiles.clear();
  clearStuckTimer();
  processedIds.clear();
}

export function teardownSseRuntime(params: {
  processedIds: Set<string>;
  setRunIdle?: boolean;
}) {
  sseState.finalized = false;
  sseState.saveResultSeen = false;
  sseState.activeThinkingId = null;
  clearStuckTimer();
  if (params.setRunIdle) {
    S().setRunStatus("idle");
  }
  S().setConnectionStatus("disconnected");
  const streaming = S().streamingContent;
  if (streaming) {
    S().finalizeStreaming(streaming);
  }
  clearThinking();
  markRunningToolsDone();
  params.processedIds.clear();
}
